import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import DetailData from "./Data/DetailData";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import EditKategori from "./Kategori/EditKategori";
import Kategori from "./Kategori/Kategori";
import TambahKategori from "./Kategori/TambahKategori";

const mediaRoutes = [
  {
    path: "/kategori_media/edit/:id",
    exact: true,
    component: EditKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_media/tambah",
    exact: true,
    component: TambahKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_media",
    exact: true,
    component: Kategori,
    auth: authRoles.all,
  },
  {
    path: "/data_media/detail/:id",
    exact: true,
    component: DetailData,
    auth: authRoles.all,
  },
  {
    path: "/data_media/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_media/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_media",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default mediaRoutes;
